import { parseDate } from '~/techstyle-shared/redux-core';

export function isPreorderable(product) {
  if (!product) {
    return false;
  }
  if (product.datePreorderExpires) {
    return Date.now() < parseDate(product.datePreorderExpires);
  }
  if (product.bundleComponentProducts) {
    return product.bundleComponentProducts.some((individualProduct) =>
      individualProduct.skus.some(
        (sku) =>
          sku.isPreorder &&
          Date.now() < parseDate(sku.dateAvailablePreorder) &&
          sku.availableQuantityPreorder > 0
      )
    );
  }
  return false;
}
